import {createSlice} from '@reduxjs/toolkit';
//types
import {ICommunicationReducer} from '@/utils/types/organization-communication.interface';
import {
	getEmailTemplate,
	getAllEmailTemplates,
	getOneEmailTemplateByType,
	updateOneEmailTemplateByType,
} from './actions';
import {
	getEmailTemplateOperation,
	pendingOperation,
	rejectedOperation,
	getOneEmailTemplateByTypeOperation,
	getAllEmailTemplatesOperation,
	updateOneEmailTemplateByTypeOperation,
} from './operations';

export const initialState: ICommunicationReducer = {
	communicationTemplate: null,
	isLoading: false,
	templates: [],
};

const organizationCommunicationStore = createSlice({
	name: 'communication',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getEmailTemplate.pending, pendingOperation);
		builder.addCase(getEmailTemplate.fulfilled, getEmailTemplateOperation);
		builder.addCase(getEmailTemplate.rejected, rejectedOperation);

		builder.addCase(getAllEmailTemplates.pending, pendingOperation);
		builder.addCase(getAllEmailTemplates.fulfilled, getAllEmailTemplatesOperation);
		builder.addCase(getAllEmailTemplates.rejected, rejectedOperation);

		builder.addCase(getOneEmailTemplateByType.pending, pendingOperation);
		builder.addCase(getOneEmailTemplateByType.fulfilled, getOneEmailTemplateByTypeOperation);
		builder.addCase(getOneEmailTemplateByType.rejected, rejectedOperation);

		builder.addCase(updateOneEmailTemplateByType.pending, pendingOperation);
		builder.addCase(updateOneEmailTemplateByType.fulfilled, updateOneEmailTemplateByTypeOperation);
		builder.addCase(updateOneEmailTemplateByType.rejected, rejectedOperation);
	},
});

export default organizationCommunicationStore.reducer;
